import { useCallback, useEffect } from 'react';
import { throttle } from 'throttle-debounce';
import { getWindow } from '../util/globals';
var win = getWindow();
export var useScrollObserver = function useScrollObserver(enabled, onScrollChange) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      enableInitialCall = _ref.enableInitialCall,
      throttleDelay = _ref.throttleDelay,
      containerRef = _ref.containerRef;

  var onChangeInternal = useCallback(function () {
    if (onScrollChange) {
      var scrollTop = 0;

      if (containerRef && containerRef.current) {
        scrollTop = containerRef.current.scrollTop;
      } else if (win) {
        scrollTop = win.scrollY || win.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
      }

      onScrollChange(scrollTop);
    }
  }, [onScrollChange, win, containerRef]);
  var onChangeInternalDecorated = useCallback(throttle(throttleDelay || 0, false, onChangeInternal), [onChangeInternal, throttleDelay]);
  useEffect(function () {
    if (enabled) {
      if (enableInitialCall) {
        onChangeInternal();
      }

      if (containerRef && containerRef.current) {
        containerRef.current.addEventListener('scroll', onChangeInternalDecorated);
      } else if (win) {
        win.addEventListener('scroll', onChangeInternalDecorated);
      }
    }

    return function () {
      if (enabled) {
        if (win) {
          win.removeEventListener('scroll', onChangeInternalDecorated);
        }

        if (containerRef && containerRef.current) {
          containerRef.current.removeEventListener('scroll', onChangeInternalDecorated);
        }
      }
    };
  }, [win, containerRef, enabled, onChangeInternalDecorated, enableInitialCall]);
};